import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../constants/ActionNameConstants';
import { VENDOR_NAME_LIST_API_URL } from '../../../../constants/ApiUrlConstants';
import { getApiRequest } from '../../../../features/axiosClient';
import { vendorNameListFailure, vendorNameListSuccess } from '../actions';

const vendorNameListPI = (action) => getApiRequest(`${VENDOR_NAME_LIST_API_URL}?VendorId=${action}`);

function* handleVendorNameList(action) {
  try {
    const response = yield call(vendorNameListPI, action.payload);
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    yield put(vendorNameListSuccess(response));
  } catch (error) {
    yield put(vendorNameListFailure(error));
  }
}

export function* watchVendorVendorNameList() {
  yield takeLatest(types.VENDOR_NAME_LIST_REQUEST, handleVendorNameList);
}
